import React, { useState, useEffect, useRef } from 'react';
import './AccuracySection.css';

const BRAND_GRAD = 'linear-gradient(90deg,#6366F1,#8B5CF6 55%,#D946EF)';

function AccuracySection() {
  const [accuracyCount, setAccuracyCount] = useState(0);
  const accuracyRef = useRef(null);

  useEffect(() => {
    const countObs = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          countObs.unobserve(entry.target);
          const dur = 1500, target = 99.5, t0 = performance.now();
          const tick = (t) => {
            let p = Math.min(1, (t - t0) / dur);
            p = 1 - Math.pow(1 - p, 3);
            setAccuracyCount(+(target * p).toFixed(1));
            if (p < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        }
      });
    }, { threshold: 0.3 });
    if (accuracyRef.current) countObs.observe(accuracyRef.current);
    return () => countObs.disconnect();
  }, []);

  return (
    <section style={{ background: '#131022', padding: '104px 56px' }}>
      <div style={{ maxWidth: 1180, margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '0.92fr 1.08fr', gap: 64, alignItems: 'center' }} className="oc-grid-2">
          <div className="oc-reveal" ref={accuracyRef}>
            <span style={{ font: '700 12px Manrope,sans-serif', letterSpacing: '0.16em', color: '#816BFF' }}>ACCURACY</span>
            <div className="oc-stat-big" style={{ fontFamily: 'Manrope,sans-serif', fontWeight: 800, fontSize: 96, lineHeight: 1, letterSpacing: '-0.03em', margin: '18px 0 0', background: BRAND_GRAD, WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>
              {accuracyCount.toFixed(1)}%<span style={{ fontSize: 54 }}>+</span>
            </div>
            <p style={{ margin: '14px 0 0', fontFamily: 'Montserrat,sans-serif', fontWeight: 700, fontSize: 22, color: '#fff' }}>field-level accuracy</p>
            <p style={{ margin: '20px 0 0', maxWidth: 460, fontFamily: 'Montserrat,sans-serif', fontSize: 18, lineHeight: 1.65, color: 'rgba(255,255,255,0.70)' }}>
              Not a tuned general model. Oculo is purpose-built for NDT, so the vast majority of documents extract with 100% accuracy, streamlined, efficient, and consistent across every contractor's reports.
            </p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }} className="oc-grid-2">
            <div className="oc-reveal" style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 14, padding: '30px 26px' }}>
              <span style={{ font: '600 12px Manrope,sans-serif', letterSpacing: '0.04em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.45)' }}>OTHER AI EXTRACTION TOOLS</span>
              <div style={{ font: '800 52px Manrope,sans-serif', color: 'rgba(255,255,255,0.78)', margin: '12px 0 4px', letterSpacing: '-0.02em' }}>~88%</div>
              <div style={{ height: 1, background: 'rgba(255,255,255,0.08)', margin: '18px 0' }} />
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
                <span style={{ font: '800 30px Manrope,sans-serif', color: '#FFA4A4' }}>14</span>
                <span style={{ font: '500 13px Manrope,sans-serif', color: 'rgba(255,255,255,0.55)', lineHeight: 1.4 }}>fields to re-check<br />on a 120-field report</span>
              </div>
              <p style={{ margin: '18px 0 0', font: '500 13px Manrope,sans-serif', lineHeight: 1.5, color: 'rgba(255,255,255,0.45)' }}>Manual review required on nearly every document.</p>
            </div>
            <div className="oc-reveal" style={{ position: 'relative', background: 'linear-gradient(180deg, rgba(99,102,241,0.14), rgba(217,70,239,0.06))', border: '1px solid rgba(129,107,255,0.45)', borderRadius: 14, padding: '30px 26px', boxShadow: '0 24px 60px -24px rgba(99,102,241,0.6)' }}>
              <span style={{ font: '700 12px Manrope,sans-serif', letterSpacing: '0.04em', textTransform: 'uppercase', color: '#B6BCFF' }}>Oculo</span>
              <div style={{ font: '800 52px Manrope,sans-serif', margin: '12px 0 4px', letterSpacing: '-0.02em', background: BRAND_GRAD, WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>99.5%+</div>
              <div style={{ height: 1, background: 'rgba(255,255,255,0.12)', margin: '18px 0' }} />
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
                <span style={{ font: '800 30px Manrope,sans-serif', color: '#02A783' }}>&lt;1</span>
                <span style={{ font: '500 13px Manrope,sans-serif', color: 'rgba(255,255,255,0.70)', lineHeight: 1.4 }}>field to re-check<br />on the same report</span>
              </div>
              <p style={{ margin: '18px 0 0', font: '600 13px Manrope,sans-serif', lineHeight: 1.5, color: 'rgba(255,255,255,0.78)' }}>Straight-through processing: most documents need zero human intervention.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AccuracySection;
